import { VIEW_SIZE_CODES, VIEW_SIZE_CONFIG } from '@/utils/Constants';

function getWidthCode(width) {
  if (width < VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.SM]) {
    return VIEW_SIZE_CODES.XS;
  }
  if (
    width >= VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.SM] &&
    width < VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.MD]
  ) {
    return VIEW_SIZE_CODES.SM;
  }
  if (
    width >= VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.MD] &&
    width < VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.LG]
  ) {
    return VIEW_SIZE_CODES.MD;
  }
  if (
    width >= VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.LG] &&
    width < VIEW_SIZE_CONFIG[VIEW_SIZE_CODES.XL]
  ) {
    return VIEW_SIZE_CODES.LG;
  }
  return VIEW_SIZE_CODES.XL;
}

export function isUp(current, value) {
  const currentWidth = VIEW_SIZE_CONFIG[current];
  const valueWidth = VIEW_SIZE_CONFIG[value];
  return currentWidth >= valueWidth;
}

export function isDown(current, value) {
  const currentWidth = VIEW_SIZE_CONFIG[current];
  const valueWidth = VIEW_SIZE_CONFIG[value];
  return currentWidth < valueWidth;
}

export default getWidthCode;



// WEBPACK FOOTER //
// ./src/utils/viewSize.js